import {TerminalResponse} from '../response.model';

export class CommonResponse extends TerminalResponse {

    constructor() {
        super ();
    }
}
